// Material
import { Button, Typography } from '@mui/material'
import { SxProps, styled } from '@mui/material/styles'
import { ExpandMoreIcon } from '@weblite/icons'
import { Alert } from '$common/input/alert'
// Icons
import { ArrowDropDownIcon } from '$common/icons/arrow-drop-down'
// Localization
import { nothing } from '$func/utils'
import { t } from '$i18n'
import { CircularLoading } from '$common/loading/circular-loading'

export function SelectButton({
  value,
  onClick,
  placeholder,
  hasError,
  errorMessage,
  className,
  sx,
  disabled,
  loading,
}: {
  value?: string
  onClick?: () => unknown // TODO: Make it required later
  placeholder?: string
  hasError?: boolean
  errorMessage?: string
  className?: string
  sx?: SxProps
  disabled?: boolean
  loading?: boolean
}) {
  return (
    <Root sx={sx}>
      <StyledButton
        className={className}
        endIcon={
          loading ? (
            <CircularLoading size={17} color="inherit" />
          ) : (
            <ExpandMoreIcon sx={{ width: '24px', height: '24px' }} />
          )
        }
        onClick={onClick}
        disabled={disabled}
      >
        <Typography
          variant="body2"
          color={value ? 'semiBlack' : 'semiLightGray'}
        >
          {value || placeholder || t('myAccountEdit.pleaseSelect')}
        </Typography>
      </StyledButton>

      {hasError && errorMessage && (
        <Alert variant="error" text={errorMessage} />
      )}
    </Root>
  )
}

SelectButton.defaultProps = {
  value: '',
  onClick: nothing,
  placeholder: '',
  hasError: false,
  errorMessage: '',
}

const Root = styled('div')`
  margin-top: 8px;
  margin-bottom: 16px;
`

const StyledButton = styled(Button)(({ theme }) => ({
  width: '100%',
  justifyContent: 'space-between',
  padding: '8px 10px',
  borderRadius: '12px',
  border: `1px solid  ${theme.palette.neutral300}`,
  background: theme.palette.neutral000,
  '&:hover': {
    borderColor: theme.palette.primary500,
  },
  '& .MuiButton-endIcon': {
    marginLeft: '2px',
    marginTop: '1px',
    color: theme.palette.neutral500,
    '& > .MuiBox-root': {
      margin: 0,
    },
  },
  '&.Mui-disabled': {
    border: `1px solid ${theme.palette.neutral200}`,
    '& svg': {
      opacity: 0.8,
    },
  },
}))
